import React, { useState, useEffect } from 'react';

const ParentEditForm = ({ profile, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    serviceType: '',
    activityPreferences: [],
    languages: [],
    searchRadius: '',
    children: [],
    phone: '',
    address: '',
    email: '',
    displayName: ''
  });

  useEffect(() => {
    if (profile) setFormData(profile);
  }, [profile]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleArrayInputChange = (e) => {
    const { name, value, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: checked 
        ? [...prev[name], value]
        : prev[name].filter(item => item !== value)
    }));
  };

  const handleChildrenUpdate = (updatedChildren) => {
    setFormData(prev => ({
      ...prev,
      children: updatedChildren
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="edit-profile-form">
      <div className="form-group">
        <label htmlFor="displayName">Display Name</label>
        <input
          type="text"
          id="displayName"
          name="displayName"
          value={formData.displayName || ''}
          onChange={handleInputChange}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="phone">Phone Number</label>
        <input
          type="tel"
          id="phone"
          name="phone"
          value={formData.phone || ''}
          onChange={handleInputChange}
        />
      </div>
      <div className="form-group">
        <label htmlFor="email">Email</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email || ''}
          onChange={handleInputChange}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="address">Address</label>
        <textarea
          id="address"
          name="address"
          value={formData.address || ''}
          onChange={handleInputChange}
        />
      </div>
      <div className="form-group">
        <label htmlFor="serviceType">Preferred Service Type</label>
        <select
          id="serviceType"
          name="serviceType"
          value={formData.serviceType}
          onChange={handleInputChange}
          required
        >
          <option value="">Select Type</option>
          <option value="nanny">Nanny</option>
          <option value="provider">Daycare Provider</option>
          <option value="both">Both</option>
        </select>
      </div>
      <div className="form-group">
        <label>Activity Preferences</label>
        <div className="checkbox-grid">
          {["Arts & Crafts", "Music", "Sports", "Outdoor Play", "Reading", "STEM Activities", "Language Learning"].map(activity => (
            <div key={activity} className="checkbox-item">
              <input
                type="checkbox"
                id={`activity-${activity}`}
                name="activityPreferences"
                value={activity}
                checked={formData.activityPreferences.includes(activity)}
                onChange={handleArrayInputChange}
              />
              <label htmlFor={`activity-${activity}`}>{activity}</label>
            </div>
          ))}
        </div>
      </div>
      <div className="form-group">
        <label>Languages</label>
        <div className="checkbox-grid">
          {["English", "Spanish", "French", "Mandarin"].map(lang => (
            <div key={lang} className="checkbox-item">
              <input
                type="checkbox"
                id={`lang-${lang}`}
                name="languages"
                value={lang}
                checked={formData.languages.includes(lang)}
                onChange={handleArrayInputChange}
              />
              <label htmlFor={`lang-${lang}`}>{lang}</label>
            </div>
          ))}
        </div>
      </div>
      <div className="form-group">
        <label htmlFor="searchRadius">Search Radius (km)</label>
        <input
          type="number"
          id="searchRadius"
          name="searchRadius"
          value={formData.searchRadius}
          onChange={handleInputChange}
          min="1"
          max="100"
        />
      </div>
      {/* ChildrenManager or children fields here, if needed */}
      <div className="form-actions">
        <button type="submit" className="save-button">Save</button>
        <button type="button" className="cancel-button" onClick={onCancel}>Cancel</button>
      </div>
    </form>
  );
};

export default ParentEditForm; 